module.exports = __webpack_public_path__ + "img/python.bf9857b3.png";